import { SerializedBaseNode } from '@/features/screenplay/components/editor/nodes/BaseNode'
import { SerializedContent } from '@/features/screenplay/components/editor/utils/JsonUtils'
import { SerializedElementNode, SerializedLexicalNode, SerializedTextNode } from 'lexical'

export function getAllTextContentNew(node: SerializedLexicalNode): string {
    if ('children' in node) {
        const elementNode = node as SerializedElementNode
        return (elementNode.children || []).map((child) => getAllTextContentNew(child)).join(' ')
    } else if ('text' in node) {
        const textNode = node as SerializedTextNode
        return textNode.text
    }
    return ''
}

export function getSceneTextContent(sceneData: SerializedContent[]): string {
    const text = sceneData
        .map((node) => getAllTextContentNew(node as unknown as SerializedLexicalNode))
        .join('\n')
    return text
}
///remove this
export function getSceneHeader(scene: SerializedBaseNode): string {
    return (
        getAllTextContentNew(scene as unknown as SerializedLexicalNode).trim() || 'Untitled Scene'
    )
}
